// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ExchangeRecordPage_wrap__3c5GW","tabs":"ExchangeRecordPage_tabs__2WcSN"};